<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @opened="onOpened" @close="onClose" width="80%" title="添加订单发票号码" :modal-append-to-body="true" :append-to-body="true">
      <el-row :gutter="15">
        <el-col :span="8">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-weight: 600">录入发票号码</span>
            </div>
            <div style="height: 400px;">
              <el-form :inline="false" size="mini" :model="formData" :rules="formDataRules" ref="formData" label-width="100px">
                <el-form-item label="发票号码" prop="invoice_number">
                  <el-input v-model="formData.invoice_number" maxlength="20" placeholder="发票号码" show-word-limit clearable></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="saveInvoice('formData')" class="el-button--operation">保存
                  </el-button>
                  <el-button @click="resetForm('formData')">重置</el-button>
                </el-form-item>
              </el-form>

            </div>
          </el-card>
        </el-col>
        <el-col :span="16">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-weight: 600">关联订单</span>
            </div>
            <div class="default-table"
                 v-loading="contractLoading"
                 element-loading-text="玩命加载中……"
                 element-loading-spinner="el-icon-loading">

              <el-table :max-height="400"
                        :data="tableData"
                        :summary-method="getSummaries"
                        show-summary
                        border>
                <el-table-column
                    width="60"
                    label="序号" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
<!--                <el-table-column key="id" label="订单ID" prop="id" align="left" :min-width="80"></el-table-column>-->
                <el-table-column key="order_no" label="订单编号" prop="order_no" header-align="center" align="left"
                                 :min-width="140"></el-table-column>
                <el-table-column key="company_name" label="乙方名称" prop="company_name" header-align="center" align="center"
                                 show-overflow-tooltip
                                 :min-width="100"></el-table-column>
                <el-table-column key="customer_name" label="客户名称" prop="customer_name" header-align="center" align="left"
                                 show-overflow-tooltip
                                 :min-width="160"></el-table-column>
                <el-table-column key="payment_account" label="订单总额" prop="payment_account" header-align="center"
                                 align="right"
                                 :min-width="110">
                  <template slot-scope="scope">
                    <span>{{ gFunc.numberFormat(scope.row.payment_account, 2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column key="contract_no" label="合同编号" prop="contract_no" header-align="center" align="center"
                                 :min-width="120"></el-table-column>
                <el-table-column key="invoice_number" label="发票号码" prop="invoice_number" header-align="center" align="center"
                                 :min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column key="payment_method" label="收款形式" prop="payment_method" header-align="center"
                                 align="center"
                                 :min-width="120"></el-table-column>
                <el-table-column key="f_remark" label="财务备注" prop="f_remark" header-align="center" align="left"></el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { batchStoreOrderInvoiceNumber} from '@/api/order'
import { gFunc } from "@/globalFunc";

export default {
  name: "adInvoicEnter",
  props: {
    orderInvoicList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      formData: {
        order_ids:[],
        invoice_number:null
      },
      formDataRules: {
        invoice_number: [
          { required: true, message: '请输入发票号码', trigger: 'blur' },
        ],
      },
      tableData: [],
      contractLoading: false,
    }
  },
  watch: {
    orderInvoicList: {
      handler: function (newVal) {
        if (newVal && newVal.length) {
          this.tableData=[...this.orderInvoicList];
        }
      },
      immediate: true
    }
  },
  methods: {
    onOpened() {
      this.formData = {}
      // this.$notify.info('添加发票窗口打开')
    },
    onClose() {
      // this.$refs['elForm'].resetFields()
    },
    close() {
      this.$emit('update:visible', false)
    },
    //表格列累计
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 0) {
          return
        }
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        // console.log(`${index}）${column.property}`)
        if (['payment_account'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }

          // // 格式化数据
          switch (column.property) {
            case 'payment_account':
              sums[index] = gFunc.numberFormat(sums[index], 2)
              break
            default:
              break
          }
        }
      })
      return sums
    },
    //提交发票号码
    saveInvoice(formName) {
      //保存发票号码：批量保存
      this.formData.order_ids = this.orderInvoicList.map((item) => {
        return item.id
      })

      this.$refs[formName].validate((valid) => {
        if (valid) {
          batchStoreOrderInvoiceNumber(this.formData).then((res) => {
            if (!res.success) {
              this.$message.error(res.message)
            } else {
              this.$message.success(res.message)
              this.$emit('afterInvoic')
              this.close()
            }
          })

        } else {

          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
}
</script>

<style scoped>

</style>
